(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('pd-range-catalog')) {
    customElements.define('pd-range-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = Array.from(this.querySelectorAll('[data-range-item]'));
        this.search = this.querySelector('[data-range-search]');
        this.sort = this.querySelector('[data-range-sort]');
        this.grid = this.querySelector('[data-range-grid]');
        if (!this.search || !this.sort || !this.grid) return;
        this.querySelector('[data-range-tools]').hidden = false;
        this.search.addEventListener('input', () => this.updateRange());
        this.sort.addEventListener('change', () => this.updateRange());
      }
      updateRange() {
        const normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[-–—]/g, ' ');
        const query = normalize(this.search.value.trim());
        const selected = this.sort.value;
        const ordered = [...this.items].sort((a, b) => {
          if (selected === 'title') return a.dataset.rangeTitle.localeCompare(b.dataset.rangeTitle);
          if (selected.startsWith('price-')) {
            const difference = Number(a.dataset.rangePrice) - Number(b.dataset.rangePrice);
            return (selected === 'price-descending' ? -difference : difference) || Number(a.dataset.rangePosition) - Number(b.dataset.rangePosition);
          }
          return Number(a.dataset.rangePosition) - Number(b.dataset.rangePosition);
        });
        let visible = 0;
        ordered.forEach(item => {
          item.hidden = !normalize(item.dataset.rangeSearchText).includes(query);
          if (!item.hidden) visible++;
          this.grid.append(item);
        });
        this.querySelector('[data-range-count]').textContent = String(visible);
        this.querySelector('[data-range-noun]').textContent = visible === 1 ? this.dataset.singular : this.dataset.plural;
        this.querySelector('[data-range-empty]').hidden = visible !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-about-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pd-about-story'))customElements.define('pd-about-story',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
    this.chapters=[...this.querySelectorAll('[data-about-chapter]')];this.objects=[...this.querySelectorAll('[data-about-object]')];this.markers=[...this.querySelectorAll('[data-about-marker]')];this.mobile=[...this.querySelectorAll('[data-about-mobile-visual]')];this.stage=this.querySelector('.pd-about__space');
    this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.desktop=matchMedia('(min-width:990px) and (min-height:650px)');this.disabled=this.reduced.matches;this.frame=0;this.inView=false;this.pointerX=0;this.pointerY=0;
    this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.draw())};
    this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(this.inView)this.queue()},{rootMargin:'150px'});this.observer.observe(this);
    window.addEventListener('scroll',()=>{if(this.inView&&!this.disabled)this.queue()},{passive:true,signal});
    window.addEventListener('resize',()=>{this.configure();this.queue()},{signal});
    this.reduced.addEventListener('change',()=>{this.disabled=this.reduced.matches;this.configure();this.queue()},{signal});this.desktop.addEventListener('change',()=>{this.configure();this.queue()},{signal});
    this.stage.addEventListener('pointermove',event=>{if(event.pointerType!=='mouse'||this.disabled)return;const r=this.stage.getBoundingClientRect();this.pointerX=(event.clientX-r.left)/r.width-.5;this.pointerY=(event.clientY-r.top)/r.height-.5;this.queue()},{passive:true,signal});
    this.stage.addEventListener('pointerleave',()=>{this.pointerX=0;this.pointerY=0;this.queue()},{signal});
    this.configure();this.queue();
  }
  configure(){this.enhanced=this.desktop.matches&&!this.disabled;this.dataset.enhanced=String(this.enhanced);if(this.disabled)this.mobile.forEach(image=>image.style.transform='none')}
  draw(){
    this.frame=0;if(this.disabled||!this.chapters.length)return;const center=innerHeight*.55;let nearest=0,distance=Infinity;
    this.chapters.forEach((chapter,i)=>{const r=chapter.getBoundingClientRect(),delta=(r.top+r.height/2-center)/innerHeight;const progress=Math.max(-1,Math.min(1,delta));if(Math.abs(delta)<distance){distance=Math.abs(delta);nearest=i}if(!this.enhanced)this.mobile[i].style.transform=`perspective(1000px) translateY(${progress*4}px) rotateX(${progress*-1.1}deg) rotateY(${progress*1.6}deg)`});
    if(!this.enhanced)return;
    const r=this.chapters[nearest].getBoundingClientRect(),progress=Math.max(-1,Math.min(1,(r.top+r.height/2-center)/innerHeight));
    this.objects.forEach((object,i)=>{object.dataset.active=String(i===nearest);if(i===nearest){object.style.setProperty('--about-y',`${progress*14}px`);object.style.setProperty('--about-rx',`${progress*-3-this.pointerY*2}deg`);object.style.setProperty('--about-ry',`${progress*6+this.pointerX*3}deg`)}});
    this.markers.forEach((marker,i)=>marker.dataset.active=String(i===nearest));this.stage.style.setProperty('--about-orb-y',`${progress*-18}px`);
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.abort?.abort();this.abort=null}
});

if(!customElements.get('pd-about-values'))customElements.define('pd-about-values',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
    this.viewport=this.querySelector('[data-value-viewport]');this.tabs=[...this.querySelectorAll('[data-value-tab]')];this.panels=[...this.querySelectorAll('[data-value-panel]')];this.prev=this.querySelector('[data-value-prev]');this.next=this.querySelector('[data-value-next]');this.count=this.querySelector('[data-value-count]');this.index=0;this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.go(index),{signal});tab.addEventListener('keydown',event=>{let target=index;if(event.key==='ArrowRight')target=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')target=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')target=0;else if(event.key==='End')target=this.tabs.length-1;else return;event.preventDefault();this.tabs[target].focus({preventScroll:true});this.go(target)},{signal})});
    this.panels.forEach((panel,index)=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.tabs[index].id)});
    this.prev.addEventListener('click',()=>this.go(this.index-1),{signal});this.next.addEventListener('click',()=>this.go(this.index+1),{signal});
    this.viewport.addEventListener('scroll',()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;const box=this.viewport.getBoundingClientRect();let distance=Infinity,index=0;this.panels.forEach((panel,i)=>{const delta=Math.abs(panel.getBoundingClientRect().left-box.left);if(delta<distance){distance=delta;index=i}});this.select(index)})},{passive:true,signal});
    this.resize=()=>this.go(this.index,false);if(typeof ResizeObserver!=='undefined'){this.observer=new ResizeObserver(this.resize);this.observer.observe(this.viewport)}else window.addEventListener('resize',this.resize,{signal});
    this.querySelector('[data-value-tabs]').hidden=false;this.querySelector('[data-value-controls]').hidden=false;this.dataset.enhanced='true';this.select(0);
  }
  select(index){this.index=index;this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1});this.panels.forEach((panel,i)=>{panel.setAttribute('aria-hidden',String(i!==index));panel.inert=i!==index;panel.tabIndex=i===index?0:-1});this.prev.disabled=index===0;this.next.disabled=index===this.panels.length-1;this.count.textContent=`${index+1} / ${this.panels.length}`}
  go(index,animate=true){index=Math.max(0,Math.min(this.panels.length-1,index));const left=this.viewport.scrollLeft+this.panels[index].getBoundingClientRect().left-this.viewport.getBoundingClientRect().left;this.select(index);this.viewport.scrollTo({left,behavior:animate&&!this.motion.matches?'smooth':'instant'})}
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.abort?.abort();this.abort=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-product-benefits')) {
    customElements.define('pd-product-benefits', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true' || window.Shopify?.designMode || !window.IntersectionObserver || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold:0.12 });
        this.querySelectorAll('.pd-benefits__metric, .pd-benefits__item').forEach(item => this.observer.observe(item));
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-visual-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pd-visual-story')) customElements.define('pd-visual-story', class extends HTMLElement {
  connectedCallback() {
    const main = document.querySelector('product-info[id^="MainProduct-"]');
    if (main) this.querySelectorAll('[data-pd-v-buy]').forEach(buy => buy.href = '#' + main.id);
    if (this.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('pd-v-seen'); this.observer.unobserve(entry.target); }
    }), {threshold:.18});
    this.querySelectorAll('.pd-v-visual-stage, .pd-v-benefit, .pd-v-steps').forEach(item => this.observer.observe(item));
  }
  disconnectedCallback() { this.observer?.disconnect(); }
});

  } catch(e) { console.error(e); }
})();
})();
